/** @type {import('tailwindcss').Config} */
module.exports = {
  // !! include all templates that use tailwind, if not, even tough you add tailwind to the page and use the classes, due to
  // tailwind tree-shaking, it will clear/purge the classes to minify the payload. Be carefull on adding tailwind classes from admin, ex: trough blocks
  // for a quick and dirty fix, add <script src="https://cdn.tailwindcss.com?plugins=forms"></script> in header, because it will not do tree-shaking and render all classes
  content: [
    // Main and Kanban content:
    './node_modules/tw-elements/dist/js/**/*.js',
    './resources/assets/js/vue/**/*.{vue,js,ts,jsx,tsx}',
    './resources/assets/js/vue/pages/candidate/auth/**/*.{vue,js,ts,jsx,tsx}',
    './resources/views/front/auth/**/*.blade.php',
    './resources/layouts/front/**/*.blade.php',
    './resources/views/front-end/kanban.blade.php',
    './resources/views/front/tw/companies/boards/show/**/*.blade.php',
    // Menu content (both regular and kanban menu):
    './resources/layouts/default/new_menu/**/*.blade.php',
    //Blocks
    './app/Blocks/**/*.blade.php'
  ],
  safelist: [
      "!block"
  ],
  media: false,
  theme: {
    screens: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      '3xl': '1180px',
      xl: '1280px',
      '2xl': '1280px'
    },
    container: {
      padding: {
        DEFAULT: '1rem',
        sm: '1rem',
        lg: '1rem',
        xl: '1rem',
        '2xl': '1rem'
      },
      screens: {
        sm: '640px',
        md: '768px',
        lg: '1024px',
        '3xl': '1180px',
        xl: '1280px',
        '2xl': '1280px'
      },
      center: true
    },
    extend: {
      colors: {
        'body-color': '#F2F4F6',
        'gray-clear': '#CCD3D9',
        primary: '#20B9A0',
        secondary: '#1D386D',
        'secondary-click': '#ff3a44',
        'secondary-hover': '#ffc5c8',
        'status-active': '#50CD89',
        'status-inactive': '#FBBF24',
        'secondary-clean': '#FF7C81',
        'blue-subtitle': '#8090A1',
        tabel: '#F7FCFC',
        'tabel-color': '#405972',
        'slate-50': 'rgb(248 250 252)',
        brandColor1: '#1D386D',
        brandColor2: '#20B9A0',
        lightGray: 'rgba(15, 35, 63, 0.05)',
        mediumGray: 'rgba(15, 35, 63, 0.5)',
        textAreaGray: '#282828',
        'blue-clean': '#00B2FF',
        warning: '#FBFF24',
        success: '#10B981',
        error: '#EF4444',
        body: '#58585E',
        'button-color': '#FFFFFF',
        'menu-primary': '#012243',
        'menu-secondary': '#FF5B62',
        grayBorder: '#e5e7eb'
      },
      screens: {
        '3xl': '1180px'
      },
      gridRow: {
        'span-16': 'span 16 / span 16'
      },
      fontFamily: {
        primary: ['Ubuntu Bold'],
        secondary: ['Ubuntu Regular'],
      },
      maxWidth: {
        default: '984px',
        box: '450px',
        'text-message': '320px',
        'box-xl': '600px',
        '4xl': '60rem'
      },
      minWidth: {
        sm: '640px',
        text: '45px'
      },
      minHeight: {
        'xs-first': '160px',
        xs: '200px',
        text: '45px'
      },
      height: {
        '50px': '50px',
        '45px': '45px',
        '67vh': '67vh',
        '27vh': '27vh'
      },
      inset: {
        'n67%': '-67%'
      },
      boxShadow: {
        '3xl': '0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)',
        redesign:
          '0px 8px 8px 0px rgba(85, 105, 135, 0.025), 0px 20px 24px 0px rgba(85, 105, 135, 0.05)',
        card: '0px 4px 6px -2px rgba(85, 105, 135, 0.02), 0px 12px 16px -4px rgba(85, 105, 135, 0.04)',
        element:
          '0px 0px 4px -2px rgba(85, 105, 135, 0.15), 0px 0px 10px -2px rgba(85, 105, 135, 0.2)'
      },
      accentColor: {
        secondary: '#FF5B62'
      },
      borderRadius: {
        app: '0.375rem'
      }
    }
  },
  variants: {
    extend: {}
  },
  plugins: [
    require('tw-elements/plugin.cjs'),
    require('@tailwindcss/forms'),
    function ({ addBase, theme, addComponents }) {
      function hexToRGB(hex) {
        const bigint = parseInt(hex.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `${r}, ${g}, ${b}`;
      }

      const primaryColor = hexToRGB(theme('colors.primary'));
      const secondaryColor = hexToRGB(theme('colors.secondary'));
      addBase({
        ':root': {
          '--tw-primary-color': primaryColor,
          '--tw-secondary-color': secondaryColor
        }
      });

      addComponents({
        '.hover-lift': {
          transition:
            'transform 0.2s ease-out, box-shadow 0.2s ease-out !important',
          '&:hover': {
            transform: 'translateY(-4px) !important',
            'box-shadow':
              '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
          }
        },
        '.hover-lift-no-shadow': {
          transition: 'transform 0.2s ease-out !important',
          '&:hover': {
            transform: 'translateY(-2px) !important'
          }
        },

        '.hover-scale': {
          transition: 'transform 0.2s ease-out, box-shadow 0.2s ease-out',
          '&:hover': {
            transform: 'scale(1.05)',
            'box-shadow':
              '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
          }
        },
        '.scrollbar-thin': {
          'scrollbar-width': 'thin',
          'scrollbar-color': 'rgba(0, 0, 0, 0.2) transparent',
          '&::-webkit-scrollbar': {
            width: '6px'
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            'background-color': 'rgba(0, 0, 0, 0.2)',
            'border-radius': '3px'
          }
        }
      });
    }
  ],
  corePlugins: {
    preflight: true,
    divideStyle: true
  }
};
